






























































import { Component, Vue, Watch } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import { Venue } from '@/interfaces/models/Venue';
import ArticleTable from '@/components/article/ArticleTable.vue';
import { Category } from '@/interfaces/models/Category';
import { Article as ArticleModel } from '@/interfaces/models/Article';
import FoodcardApiService from '@/api/http/FoodcardApiService';
import { AxiosResponse } from 'axios';
import { toUrl } from '@/util/helper';
import Filter from '@/interfaces/api/Filter';
import { Page } from '@/interfaces/api/Page';

const foodcard = namespace('foodcard');
const venue = namespace('venue');

@Component({
  components: { ArticleTable, Article, VWrapper },
})
export default class Article extends Vue {
  @venue.State('active') public venue!: Venue;

  @foodcard.Action('setCategoryFilter') public setCategoryFilter!: any;
  @foodcard.Action('setArticleFilter') public setArticleFilter!: any;
  @foodcard.Action('makeArticleVisible') public makeArticleVisible!: any;
  @foodcard.Action('hideArticle') public hideArticle!: any;
  @foodcard.Action('updateArticle') public updateArticle!: any;
  @foodcard.Action('destroyArticle') public destroyArticle!: any;
  @foodcard.Action('activateArticle') public activateArticle!: any;
  @foodcard.Action('deactivateArticle') public deactivateArticle!: any;
  @foodcard.Action('makeControlArticle') public makeControlArticle!: any;
  @foodcard.Action('undoControlArticle') public undoControlArticle!: any;
  @foodcard.Action('fetchCategories') public getCategories!: any;
  @foodcard.Action('copyArticle') public copyArticle: any;
  @foodcard.Action('fetchArticles') public getArticles!: any;
  @foodcard.State((state) => state.articlePagination.total) public total!: number[];
  @foodcard.State('articleFilter') public articleFilter!: Filter;

  @foodcard.State('categories') protected categories!: Category[];
  @foodcard.State('articles') protected items!: ArticleModel[];

  get selectableCategories() {
    return this.categories.map((i: Category) => {
      return {
        value: i._id,
        text: i.name.de,
      };
    });
  }

  copyDialog: { visible: boolean; value: null | ArticleModel; category: string | null } = {
    visible: false,
    value: null,
    category: null,
  };

  public mounted(): void {
    this.fetchCategories();
  }

  public doCopyArticle() {
    this.copyArticle({
      category: this.articleFilter.category,
      id: this.copyDialog.value!._id,
      newId: this.copyDialog.category,
    });
    this.resetCopyModal();
  }

  public showCopyModal(item: ArticleModel) {
    this.copyDialog.value = item;
    this.copyDialog.visible = true;
  }

  public resetCopyModal() {
    this.copyDialog.value = null;
    this.copyDialog.visible = false;
  }

  public async destroy(art: ArticleModel) {
    this.$startLoading('article');
    await this.destroyArticle({ id: art._id });
    this.$stopLoading('article');
  }

  public updateProp(data: { original: ArticleModel; field: string; value: string }) {
    const update: any = {};
    update[data.field] = data.value;
    this.updateArticle({ id: data.original._id, category: this.articleFilter.category, ...update });
  }

  public async onPageChange(page: Page) {
    if (this.articleFilter.category) {
      this.$startLoading('article');
      await this.getArticles(page);
      this.$stopLoading('article');
    }
  }

  public async onCategoryChange(category: { category: string }) {
    if (category.category !== this.articleFilter.category) {
      this.setArticleFilter(category);
      this.$startLoading('article');
      await this.getArticles({ page: 1 });
      this.$stopLoading('article');
    }
  }

  @Watch('venue')
  public async onVenueChange() {
    this.fetchCategories();
  }

  public async fetchCategories() {
    if (this.venue && this.venue._id) {
      this.setCategoryFilter({ venue: this.venue._id });
      this.$startLoading('category');
      await this.getCategories();
      this.$stopLoading('category');
    }
  }

  public async toggleVisibility({ item, value }: { item: ArticleModel; value: boolean }) {
    this.$startLoading('article');
    if (value) {
      this.hideArticle({ venue: this.venue._id, articles: [item._id] });
    } else {
      this.makeArticleVisible({ venue: this.venue._id, articles: [item._id] });
    }
    this.$stopLoading('article');
  }

  public async toggleControl({ item, value }: { item: ArticleModel; value: boolean }) {
    this.$startLoading('article');
    if (value) {
      this.undoControlArticle({ venue: this.venue._id, articles: [item._id] });
    } else {
      this.makeControlArticle({ venue: this.venue._id, articles: [item._id] });
    }
    this.$stopLoading('article');
  }

  public async toggleActivation({ item, value }: { item: ArticleModel; value: boolean }) {
    this.$startLoading('article');
    if (value) {
      this.deactivateArticle({ venue: this.venue._id, articles: [item._id] });
    } else {
      this.activateArticle({ venue: this.venue._id, articles: [item._id] });
    }
    this.$stopLoading('article');
  }

  public async exportFoodcard() {
    const api: FoodcardApiService = new FoodcardApiService();
    this.$startLoading('foodcard');

    const res: AxiosResponse<BlobPart> = await api.exportFoodcard({ id: this.venue._id });

    if (res.data) {
      toUrl(res.data, `foodcard-${this.venue.name}.csv`);
    }
    this.$stopLoading('foodcard');
  }
}
